import { Button, Stack } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { WizardQuestions_Question_WizardContingencyQuestion_Fragment } from "../../documents/WizardQuestions.generated.js";
import { contingencyAction } from "./answerToItemAction.js";
import { WizardQuestionMedia } from "./WizardQuestionMedia.js";
import { WizardRendererProps } from "./WizardRendererProps.js";

/** A contingent item: include it or not. */
export const WizardContingencyRenderer = ({
  question,
  onAnswer,
  disabled,
}: WizardRendererProps<WizardQuestions_Question_WizardContingencyQuestion_Fragment>) => {
  const { t } = useTranslate(["Global"]);
  const [included, setIncluded] = React.useState<boolean | null>(
    question.preselected
  );

  React.useEffect(
    () => setIncluded(question.preselected),
    [question.preselected]
  );

  const choose = (value: boolean) => {
    setIncluded(value);
    void onAnswer(contingencyAction(question.itemId, value));
  };

  return (
    <Stack direction="column" spacing={2}>
      <WizardQuestionMedia media={question.media} />
      <Stack direction="row" spacing={1}>
        <Button
          variant={included === true ? "contained" : "outlined"}
          aria-pressed={included === true}
          disabled={disabled}
          onClick={() => choose(true)}
        >
          {t("Yes", { ns: "Global" })}
        </Button>
        <Button
          variant={included === false ? "contained" : "outlined"}
          aria-pressed={included === false}
          disabled={disabled}
          onClick={() => choose(false)}
        >
          {t("No", { ns: "Global" })}
        </Button>
      </Stack>
    </Stack>
  );
};
